import { render, staticRenderFns } from "./SiteCredits.vue?vue&type=template&id=48d00b7c&"
import script from "./SiteCredits.vue?vue&type=script&lang=js&"
export * from "./SiteCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports